import React from 'react';
import iconTrained from 'Assets/layout/profile/attributes/douleutaras-trained.svg';
import iconLanguage from 'Assets/layout/profile/attributes/language.svg';
import iconIroning from 'Assets/layout/profile/attributes/ironing.svg';
import iconNoIroning from 'Assets/layout/profile/attributes/no-ironing.svg';
import iconPets from 'Assets/layout/profile/attributes/pets.svg';
import iconNoPets from 'Assets/layout/profile/attributes/no-pets.svg';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { sellerProfilesSelectors } from 'Douleutaras/redux/data/seller/sellerProfilesSlice';
import { CleanerSettings } from 'Douleutaras/types/index';

import ProCleanerAttributesLoader from './loaders/ProCleanerAttributesLoader';
import './ProCleanerAttributes.scss';

const useCleanerAcceptanceText = (cleanerSettings: CleanerSettings) => {
  const { t } = useTranslation();

  if (!cleanerSettings) {
    return {};
  }

  return {
    petsAcceptanceText: cleanerSettings?.acceptsPets
      ? t('T.PROS-PROFILE.ATTRIBUTE.PETS')
      : t('T.PROS-PROFILE.ATTRIBUTE.PETS-NO'),
    ironingText: cleanerSettings?.ironing
      ? t('T.PROS-PROFILE.ATTRIBUTE.IRONING')
      : t('T.PROS-PROFILE.ATTRIBUTE.IRONING-NO'),
    speaksLanguagesText: cleanerSettings?.languages?.length > 1
      ? `${t('T.PROS-PROFILE.ATTRIBUTE.SPEAKS')} ${cleanerSettings?.languages.join(', ')}`
      : `${t('T.PROS-PROFILE.ATTRIBUTE.SPEAKS-ONLY')} ${cleanerSettings?.languages[0]}`
  };
};

const ProCleanerAttributes = ({ username }) => {
  const { t } = useTranslation();

  const profile = useAppSelector(state => sellerProfilesSelectors.selectByUsername(state, username));
  const { loading } = useAppSelector(state => state.sellerProfiles);
  const cleanerSettings = profile?.attributes?.cleanerSettings;

  const { petsAcceptanceText, ironingText, speaksLanguagesText } = useCleanerAcceptanceText(profile?.attributes?.cleanerSettings);

  if (loading) {
    return (
      <ProCleanerAttributesLoader />
    );
  }

  // Hide cleaner badges if no data
  if (!cleanerSettings) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  return (
    <>
      <ul styleName="attributes">
        <li styleName="attributes__item">
            <span styleName="attributes__icon">
              <img src={iconTrained} alt={t('T.PROS-PROFILE.ATTRIBUTE.TRAINED')}/>
            </span>
          <span styleName="attributes__text">{t('T.PROS-PROFILE.ATTRIBUTE.TRAINED')}</span>
        </li>
      </ul>
      <ul styleName="attributes">
        <li styleName="attributes__item">
          <span styleName="attributes__icon">
            <img src={iconLanguage} alt={speaksLanguagesText}/>
          </span>
          <span styleName="attributes__text">
            {speaksLanguagesText}
          </span>
        </li>
        <li styleName="attributes__item">
          <span styleName="attributes__icon">
            <img src={cleanerSettings?.ironing ? iconIroning : iconNoIroning} alt={ironingText}/>
          </span>
          <span styleName="attributes__text attributes__text--no-wrap">{ironingText}</span>
        </li>
        <li styleName="attributes__item">
          <span styleName="attributes__icon">
            <img src={cleanerSettings?.acceptsPets ? iconPets : iconNoPets} alt={petsAcceptanceText}/>
          </span>
          <span styleName="attributes__text attributes__text--no-wrap">
            { petsAcceptanceText }
          </span>
        </li>
      </ul>
    </>
  );
};

export default ProCleanerAttributes;
